// import axios from 'axios';
// import { history } from '../../../History';
// import { message } from 'antd';
// import config from '../../../config/api';
// import { togglePreloader } from '../App/AppActions';

// export const loginRequest = () => ({
//   type: 'LOGIN_REQUEST'
// });

// export const loginSuccess = (data) => ({
//   type: 'LOGIN_SUCCESS',
//   data
// });

// export const loginFailure = () => ({
//   type: 'LOGIN_FAILURE'
// });

// export const logout = () => ({
//   type: 'LOGOUT'
// });

// export const resetAuthReducer = () => ({
// 	type: 'RESET_AUTH_REDUCER'
// });

// export const startLogin = (id_token) => {
// 	return function(dispatch) {
// 		dispatch(togglePreloader(true));
// 		const form_data = {
// 			cmd: 'user:auth',
// 			idtoken: id_token
// 		};
// 		axios({
// 			method: 'post',
// 			url: `${config.api_url}`,
// 			data: form_data
// 	})
// 		.then(response => {
// 			console.log(response);
// 			if(response.data.reply.code === 200) {
// 				let _responseString = JSON.stringify(response.data.reply.message);
// 				sessionStorage.setItem('checkAuth',true);
// 				sessionStorage.setItem('user',_responseString);
// 				dispatch(loginSuccess(response.data.reply.message));
// 				history.push('/home');
// 				dispatch(togglePreloader(false));
// 			}
// 			else if(response.data.reply.code === 400) {
// 				message.error('Oops! Something went wrong. Please try again!');
// 				sessionStorage.clear();
// 				dispatch(loginFailure());
// 				dispatch(togglePreloader(false));
// 				history.push('/');
// 			}
// 		})
// 		.catch((error) => {
// 			message.error('Oops! Something went wrong. Please try again!');
// 			sessionStorage.clear();
// 			dispatch(loginFailure());
// 			dispatch(togglePreloader(false));
// 			history.push('/');
// 		})
// 	}
// };

// export const startLogout = () => {
// 	console.log('cal func');
// 	return function(dispatch) {
// 		const token = JSON.parse(sessionStorage.getItem('user')).token;
// 		const form_data = {
// 			cmd: 'user:auth',
// 			auth: { key: token },
// 			invalidate: true
// 		};
// 		axios({
// 			method: 'post',
// 			url: `${config.api_url}`,
// 			data: form_data
// 	})
// 		.then(response => {
// 			console.log(response);
// 			if(response.data.reply.code === 200) {
// 				sessionStorage.clear();
// 				dispatch(logout());
// 				history.push('/');
// 			}
// 		})
// 		.catch((error) => {
// 			console.log(error);
// 		})
// 	}
// };
import axios from "axios";
import config from "../../../config/api";

import { signIn, signOut } from "../../../components/Login/MsLoginConfig";

export const loginRequest = () => ({
  type: "LOGIN_REQUEST",
});

export const loginSuccess = (data) => ({
  type: "LOGIN_SUCCESS",
  data,
});

export const loginFailure = () => ({
  type: "LOGIN_FAILURE",
});

export const logoutSuccess = () => ({
  type: "LOGOUT_SUCCESS",
});

export const logoutFailure = () => ({
  type: "LOGOUT_SUCCESS",
});

export const resetAuthReducer = () => ({
  type: "RESET_AUTH_REDUCER",
});

export const startLogin = (token) => {
  return function (dispatch) {
    signIn(dispatch);
  };
};

export const startLogout = () => {
  return function (dispatch) {
    const token = JSON.parse(sessionStorage.getItem("user")).data.token;
    const form_data = {
      // ms_token: signedToken,
      Authorization: token,
      cmd: "auth:ms-logout",
    };
    axios({
      // method: 'post',
      // url: `${config.api.base_url}/api/auth/ms-login`,
      // data: { ms_token: signedToken }
      method: "post",
      url: `${config.api_url}`,
      data: form_data,
    })
      // axios.get(`${config.api.base_url}${config.api.auth.logout}`)
      .then((response) => {
        dispatch({ type: "USER_LOGOUT" });
        signOut();
      })
      .catch((error) => {
        console.error(error);
        dispatch(logoutFailure());
      });
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/Auth/AuthActions.js